import { Nen3140Score } from './Nen3140Score';

export function nen3140ScoreToConditionScore(nen3140Score?: Nen3140Score) {
    switch (nen3140Score) {
        case 'OK':
            return '0';
        case 'A':
            return '1';
        case 'B':
            return '2';
        case 'C':
            return '3';
        case 'D':
            return '4';
        case 'E':
            return '5';
        case 'F':
            return '6';
        case 'NVT':
            return '7';
        default:
            return 'U';
    }
}
